import { createGenericColumn } from '../../../utils/table-headers-utils';

export const collectionTableColumns = [
  createGenericColumn('Media Name', true),
  createGenericColumn('Owner'),
];

export const collectionAddMediaColumns = [createGenericColumn('Media Name', true)];
